module.exports = __webpack_public_path__ + "static/cx-slider2-fc8b24d0515f8d106a633604b4f1ec59.jpeg";